import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=1603cdb3"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__